import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";

export function useInsertNoteHistory() {
    const { oktaAuth } = useOktaAuth();

    function insertNoteHistory(inputParameters) {
        let accessToken = oktaAuth.getAccessToken();

        let apiParameters = {
            user: inputParameters.user,
            mpid: inputParameters.mpid,
            stid: inputParameters.stid,
            statusFlag: inputParameters.statusFlag,
            note: inputParameters.note
        };

        axios.post(
            "api/MissingRemittances/AdminMissingRemittanceNotesUpdate",
            apiParameters,
            {
                headers: { Authorization: `Bearer ${accessToken}` },
            })
            .then((response) => {
                console.log("Post request successful:", response);
                inputParameters.callback();
            })
            .catch((e) => {
                console.log("Post request failed:", e);
            });
    }

    return useMutation({
        mutationFn: async (mutateParameter) => {
            insertNoteHistory(mutateParameter);
        }
    });

}